import { render, staticRenderFns } from "./d-new-bookshelf-entry-activity.vue?vue&type=template&id=24ca6e7a&"
import script from "./d-new-bookshelf-entry-activity.vue?vue&type=script&lang=js&"
export * from "./d-new-bookshelf-entry-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports